import { useTheme } from '@mui/material/styles';
import { defaultSpacingPresets } from 'hooks/useGetSpacing';
import { ActualIconProps } from 'mobx/commonTypes';
import React, { useContext } from 'react';
import { UiContext } from 'uiContext';
import cx from 'classnames';

export default function IconCone({
  onClick,
  extColor,
  isAutoscallable = true,
  sizeKey = '16x16',
  style,
}: ActualIconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.customBackgrounds.contrast;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      style={style}
      className={cx('icon IconCone', onClick ? '' : 'icon_disabled')}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 17 16"
      fill={fill}
    >
      <path d="M10.0025 6.59392L8.66237 2.84214C8.61367 2.70544 8.52387 2.58717 8.40529 2.50353C8.2867 2.4199 8.14514 2.375 8.00003 2.375C7.85492 2.375 7.71336 2.4199 7.59478 2.50353C7.47619 2.58717 7.38639 2.70544 7.33769 2.84214L5.99753 6.59392H10.0025ZM11.7603 11.5157L10.7556 8.70324H5.24448L4.23972 11.5157H11.7603ZM3.07816 12.2188C2.89168 12.2188 2.71283 12.2929 2.58097 12.4247C2.44911 12.5566 2.37503 12.7354 2.37503 12.9219C2.37503 13.1084 2.44911 13.2872 2.58097 13.4191C2.71283 13.5509 2.89168 13.625 3.07816 13.625H12.9219C13.1084 13.625 13.2872 13.5509 13.4191 13.4191C13.551 13.2872 13.625 13.1084 13.625 12.9219C13.625 12.7354 13.551 12.5566 13.4191 12.4247C13.2872 12.2929 13.1084 12.2188 12.9219 12.2188H3.07816Z" />
    </svg>
  );
}
